import * as Diagram from "../../../../components/diagram";

export const TableGroup = {
  label: "追蹤項目&諮詢類別(2024年)",
  key: "TableGroup",
  path: "HealthAnalysisManagement/TableGroup",
  api: "TCS_V_EyesS01",
  render: (options) => (
    <Diagram.HealthAnalysisManagement.TableGroup {...options} />
  ),
  isRaw: true,
  isPage: true,
  page: null,
  isRowSum: true,
  isColSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "project",
      field: "project",
      header: "員工健康追蹤項目",
    },
    {
      key: "type",
      field: "type",
      header: "諮詢類別",
    },
  ],
  columns: [
    ...Array.from({ length: 12 }, (_, i) => ({
      key: `month_${i + 1}`,
      field: `month_${i + 1}`,
      header: `${i + 1}月`,
    })),
  ],
};
